/*eslint-disable*/
import React from 'react';
import { Col, Row, Typography } from 'antd';

const { Text } = Typography;

const FinancialTermsConditions = ({ screen, form }) => {
	return (
		<Row gutter={[16, 0]}>
			<Col xs={24}>
				{/* <Text type="secondary" style={{ fontSize: '14px', fontStyle: 'italic' }}>
					Financial Terms & Conditions section is not applicable for Decommission Asset functionality. Only retirement-specific fields are
					relevant for this process.
				</Text> */}
			</Col>
		</Row>
	);
};

export default FinancialTermsConditions;
